import { Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable}  from 'rxjs';
import {DataService} from './data.service';

@Injectable({
  providedIn: 'root'
})
export class EditfacultyService implements Resolve <any>{

  constructor(private dataa:DataService) { }
  resolve (route:ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>{
let name = route.paramMap.get('name');
console.log(name)
   return this.dataa.returnee('faculties/'+name);


 }
}
